import script from "./ResetView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetView.vue?vue&type=script&setup=true&lang=js"

import "./ResetView.vue?vue&type=style&index=0&id=3793eaad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3793eaad"]])

export default __exports__